/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */

export const HS_CONTACT_ID = "0-1";
export const PORTAL_ID = atob("ODY1ODIxMw==");
export const FORM_ID = atob("MWQzNGE4MTQtMjAwMS00ZGJiLTg3ZWYtYTM5YTc3MzYxNjE4");
export const SUBMISSION_URL = `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`;
export const SENTRY_EVENT_MSG = "Failed to submit to hubspot";
